import { ITableFilters } from '@/interfaces/powerMarkets/table/ITableFilters.ts';
import {
    IMetricModule, BoaIds,
    IModule,
} from './IModule.ts';
import { IModuleChartConfig } from './charts/IModuleChartConfig.ts';

export enum ModulePresetType {
    DialMetric = 'DialMetric',
    Metric = 'Metric',
    Chart = 'Chart',
    ForecastHistoryChart = 'ForecastHistoryChart',
    LiveTable = 'LiveTable',
    BoaDashboard = 'BoaDashboard',
    AncillaryMetric = 'AncillaryMetric',
    AncillaryChart = 'AncillaryChart',
    BoaLeaderboard = 'BoaLeaderboard',
    Treemap = 'Treemap',
    NivEvolution = 'NivEvolution',
}

export type IModulePresetMetric = IMetricModule['metricNames'];

export interface IModulePresetAncillaryChart {
    type: string;
    series: string;
    option: string;
}

export interface IModulePresetForecastHistoryChart {
    name: string;
    series: string;
    option: string;
    daysForward: number;
}

export interface IModulePresetLiveTable {
    type: string;
    country: string;
    filters: null | ITableFilters;
}

export type IModulePresetAncillaryMetric = string;

export type IModulePresetBoaDashboard = BoaIds;

export type IModulePresetTreeMap = null;

export interface IModulePresetBoaLeaderboard {
    type: BoaIds;
}

export interface IModulePreset {
    module:
    IModulePresetMetric
    | IModulePresetAncillaryChart
    | IModulePresetForecastHistoryChart
    | IModulePresetLiveTable
    | IModulePresetAncillaryMetric
    | IModulePresetBoaLeaderboard
    | IModuleChartConfig
    | IModulePresetBoaDashboard
    | IModulePresetTreeMap;
    type: ModulePresetType;
    width?: number | string | null;
    height?: number | string | null;
    size?: string | null;
}

export function isModulePresetArray (
    modules: IModule[] | IModulePreset[],
): modules is IModulePreset[] {
    return modules.every(module => {
        if (!('type' in module)) return false;
        if (!Object.values(ModulePresetType).includes(module.type)) return false;
        if (!('module' in module)) return false;
        return true;
    });
}
